import { render, staticRenderFns } from "./ChamadasTable.vue?vue&type=template&id=37d7e698&scoped=true"
import script from "./ChamadasTable.vue?vue&type=script&lang=js"
export * from "./ChamadasTable.vue?vue&type=script&lang=js"
import style0 from "./ChamadasTable.vue?vue&type=style&index=0&id=37d7e698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7e698",
  null
  
)

export default component.exports